import gql from 'graphql-tag';
import _ from 'lodash';
import { client } from '../App';

export const GET_INDICATORS_SUCCESS = 'GET_INDICATORS_SUCCESS';
export const GET_INDICATORS_FAILURE = 'GET_INDICATORS_FAILURE';

function getIndicator(indicator) {
  return {
    id: null,
    dbName: [indicator.name],
    filterName: indicator.name,
    group: indicator.group || 'General Group',
    stage: indicator.stgName || 'Social Impact',
    checked: false,
    disabled: false,
    tabId: '4'
  };
}

function parseIndicatorsResponse(results) {
  /* Returns a section made with unrepeated services and indicators
  used to build the checkboxes of impact tab */

  const indicators = [];
  results.data.allPortfolios.edges.forEach(portfolio => {
    portfolio.node.investments.edges.forEach(investment => {
      investment.node.allocations.edges.forEach(allocation => {
        allocation.node.report.results.edges.forEach(result => {
          indicators.push(getIndicator(result.node.indicator));
        });
      });
    });
  });

  const sortedIndicators = _.orderBy(indicators, ['filterName'], ['asc']);
  const sections = _(sortedIndicators)
    .groupBy(indicator => indicator.group)
    .map((filters, title) => {
      const filterWithSegments = _(filters)
        .groupBy(indicator => indicator.stage)
        .map((ind, name) => ({
          name,
          filters: _.uniqBy(
            ind,
            indicator => indicator.filterName
          ).map((indicator, id) => ({ ...indicator, id: `${id}` }))
        }))
        .value();
      return {
        title,
        stages: filterWithSegments
      };
    })
    .value()
    .map((section, idx) => ({ ...section, id: `${idx + 2}` }));
  return sections;
}

function getIndicatorsSuccess(results) {
  return {
    type: GET_INDICATORS_SUCCESS,
    payload: parseIndicatorsResponse(results)
  };
}

function getIndicatorsFailure(error) {
  return {
    type: GET_INDICATORS_FAILURE,
    payload: error
  };
}

export function getIndicators() {
  return dispatch => {
    client
      .query({
        query: gql`
          {
            allPortfolios(first: 5) {
              edges {
                node {
                  investments(first: 5) {
                    edges {
                      node {
                        allocations(first: 5) {
                          edges {
                            node {
                              report {
                                results(first: 5) {
                                  edges {
                                    node {
                                      indicator {
                                        dbId
                                        name
                                        group
                                        stgName
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `
      })
      .then(results => dispatch(getIndicatorsSuccess(results)))
      .catch(error => getIndicatorsFailure(error));
  };
}
